import CircularProgress from '@mui/material/CircularProgress';

import { Alert } from '@mui/material';

import { useEffect, useState } from 'react';

import { News, useNews } from 'api/news';

import { Box, Button, CustomBox, SLIDER_SETTINGS } from 'common';

import { NewsCard } from 'widgets/cards';
import Slider from 'react-slick';

import { newsLabels } from '../../locales/translations';
import { useLanguage } from '../../context/LanguageContext';

export const NewsComponent = () => {
    const settings = SLIDER_SETTINGS;
    const { language } = useLanguage();
    const buttonLabel = newsLabels.allNewsButton[language];
    const title = newsLabels.newsTitle[language];

    const [newsList, setNewsList] = useState<News[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const { onGetAllNews } = useNews();

    useEffect(() => {
        (async () => {
            try {
                const result = await onGetAllNews();
                if (result.success) {
                    const filteredAndSortedNews = result.data
                        .filter((newsItem: News) => newsItem.show)
                        .sort((a: News, b: News) =>
                            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                        );
                    setNewsList(filteredAndSortedNews);
                } else {
                    setError('Произошла ошибка при загрузке новостей');
                }
            } catch (error: any) {
                setError(error.message || 'Неизвестная ошибка');
            } finally {
                setLoading(false);
            }
        })();
    }, [onGetAllNews]);

    return (
        <>
            {newsList.length !== 0 ? (
                <CustomBox title={title}>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <CircularProgress />
                        </Box>
                    ) : error ? (
                        <Alert severity="error">{error}</Alert>
                    ) : (
                        <Slider {...settings}>
                            {newsList.map((newsItem) => (
                                <Box key={newsItem.id} sx={{ padding: 2, display: 'flex', justifyContent: 'center' }}>
                                    <NewsCard newsItem={newsItem} />
                                </Box>
                            ))}
                        </Slider>
                    )}

                    <Box sx={{ paddingTop: 6, display: 'flex', justifyContent: 'center' }}>
                        <Button variant="contained" color="error" href="/news">
                            {buttonLabel}
                        </Button>
                    </Box>
                </CustomBox>
            ) : (<></>)}
        </>
    );
};
